import { render, staticRenderFns } from "./HotelInfo.vue?vue&type=template&id=738f85e0&scoped=true&"
import script from "./HotelInfo.vue?vue&type=script&lang=js&"
export * from "./HotelInfo.vue?vue&type=script&lang=js&"
import style0 from "./HotelInfo.vue?vue&type=style&index=0&id=738f85e0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "738f85e0",
  null
  
)

export default component.exports